// GENERATED FILE — do not edit.
//
// Produced by scripts/generate-symbol-geometry.mjs from
// frontend/shared/src/commonMain/kotlin/sk/myslikrok/shared/Symbols/SymbolCatalogue.kt.
//
// The two apps read that Kotlin directly. The web cannot, so it reads this — generated rather than typed,
// because 32 hand-copied coordinate sets would diverge silently, and the tasks that would break are the
// ones measuring whether a child can tell a shape from its mirror.
//
// Regenerate with: npm run generate:symbols

import type { SymbolShape } from './symbolShape';

export const ROTATABLE_SYMBOL_NAMES: ReadonlySet<string> = new Set(["arrow","flag","boot","hook","chair","key"]);

export const SYMBOL_SHAPES: Readonly<Record<string, SymbolShape>> = {
  "arrow": {
    "name": "arrow",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 4
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 6,
          "y": 10
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 4
        },
        {
          "kind": "lineTo",
          "x": 18,
          "y": 10
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 13
        },
        {
          "kind": "lineTo",
          "x": 18,
          "y": 13
        }
      ]
    ],
    "fills": []
  },
  "flag": {
    "name": "flag",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 6,
          "y": 21
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 3
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 6,
          "y": 4
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 7
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 10
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 13
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 15
        }
      ]
    ],
    "fills": []
  },
  "boot": {
    "name": "boot",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 8,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 13
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 16
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 21
        },
        {
          "kind": "lineTo",
          "x": 8,
          "y": 21
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 13,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 18
        }
      ]
    ],
    "fills": []
  },
  "hook": {
    "name": "hook",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 15,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 14
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 15,
          "y": 14
        },
        {
          "kind": "curveTo",
          "c1x": 15,
          "c1y": 19,
          "c2x": 15,
          "c2y": 21,
          "x": 10,
          "y": 21
        },
        {
          "kind": "curveTo",
          "c1x": 5,
          "c1y": 21,
          "c2x": 5,
          "c2y": 17,
          "x": 8,
          "y": 16
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 15,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 5
        }
      ]
    ],
    "fills": []
  },
  "chair": {
    "name": "chair",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 7,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 14
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 7,
          "y": 21
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 18,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 18,
          "y": 21
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 9
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 9
        }
      ]
    ],
    "fills": []
  },
  "key": {
    "name": "key",
    "strokes": [
      [
        {
          "kind": "circle",
          "cx": 7,
          "cy": 9,
          "radius": 4
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 10,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 20
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 16,
          "y": 15
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 18
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 19,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 16,
          "y": 21
        }
      ]
    ],
    "fills": []
  },
  "dog": {
    "name": "dog",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 5,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 5,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 9,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 13
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 9
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 5,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 8,
          "y": 5
        },
        {
          "kind": "lineTo",
          "x": 9,
          "y": 9
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 20,
          "y": 9
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 16,
          "y": 10
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 9,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 9,
          "y": 21
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 17,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 21
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 10,
          "cy": 11,
          "radius": 1
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 15,
          "cy": 11,
          "radius": 1
        }
      ]
    ]
  },
  "cat": {
    "name": "cat",
    "strokes": [
      [
        {
          "kind": "circle",
          "cx": 12,
          "cy": 13,
          "radius": 7
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 6
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 17,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 18,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 6
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 10,
          "y": 15
        },
        {
          "kind": "lineTo",
          "x": 14,
          "y": 15
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 9,
          "cy": 12,
          "radius": 1
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 15,
          "cy": 12,
          "radius": 1
        }
      ]
    ]
  },
  "horse": {
    "name": "horse",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 6,
          "y": 21
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 4
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 10
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 11,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 21
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 19,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 8
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 13,
          "cy": 7,
          "radius": 1
        }
      ]
    ]
  },
  "rabbit": {
    "name": "rabbit",
    "strokes": [
      [
        {
          "kind": "circle",
          "cx": 12,
          "cy": 15,
          "radius": 6
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 9,
          "y": 10
        },
        {
          "kind": "lineTo",
          "x": 8,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 9
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 15,
          "y": 10
        },
        {
          "kind": "lineTo",
          "x": 16,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 9
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 11,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 17
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 10,
          "cy": 14,
          "radius": 1
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 14,
          "cy": 14,
          "radius": 1
        }
      ]
    ]
  },
  "bear": {
    "name": "bear",
    "strokes": [
      [
        {
          "kind": "circle",
          "cx": 12,
          "cy": 14,
          "radius": 7
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 6,
          "cy": 7,
          "radius": 3
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 18,
          "cy": 7,
          "radius": 3
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 10,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 14,
          "y": 17
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 9,
          "cy": 12,
          "radius": 1
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 15,
          "cy": 12,
          "radius": 1
        }
      ]
    ]
  },
  "fox": {
    "name": "fox",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 9,
          "y": 11
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 11
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 6
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 9,
          "y": 11
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 11
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 12
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 20,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 18,
          "y": 12
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 10,
          "cy": 13,
          "radius": 1
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 14,
          "cy": 13,
          "radius": 1
        }
      ]
    ]
  },
  "frog": {
    "name": "frog",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 18
        },
        {
          "kind": "curveTo",
          "c1x": 4,
          "c1y": 10,
          "c2x": 20,
          "c2y": 10,
          "x": 20,
          "y": 18
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 8,
          "cy": 8,
          "radius": 3
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 16,
          "cy": 8,
          "radius": 3
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 9,
          "y": 15
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 15
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 8,
          "cy": 8,
          "radius": 1
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 16,
          "cy": 8,
          "radius": 1
        }
      ]
    ]
  },
  "bird": {
    "name": "bird",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 14
        },
        {
          "kind": "curveTo",
          "c1x": 4,
          "c1y": 8,
          "c2x": 14,
          "c2y": 6,
          "x": 18,
          "y": 10
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 9
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 12
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 19,
          "y": 12
        },
        {
          "kind": "curveTo",
          "c1x": 19,
          "c1y": 18,
          "c2x": 10,
          "c2y": 20,
          "x": 4,
          "y": 14
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 9,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 14,
          "y": 15
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 16,
          "cy": 10,
          "radius": 1
        }
      ]
    ]
  },
  "fish": {
    "name": "fish",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 3,
          "y": 12
        },
        {
          "kind": "curveTo",
          "c1x": 8,
          "c1y": 5,
          "c2x": 16,
          "c2y": 5,
          "x": 19,
          "y": 12
        },
        {
          "kind": "curveTo",
          "c1x": 16,
          "c1y": 19,
          "c2x": 8,
          "c2y": 19,
          "x": 3,
          "y": 12
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 19,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 22,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 22,
          "y": 16
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": [
      [
        {
          "kind": "circle",
          "cx": 8,
          "cy": 11,
          "radius": 1
        }
      ]
    ]
  },
  "bee": {
    "name": "bee",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 6,
          "y": 12
        },
        {
          "kind": "curveTo",
          "c1x": 6,
          "c1y": 7,
          "c2x": 18,
          "c2y": 7,
          "x": 18,
          "y": 12
        },
        {
          "kind": "curveTo",
          "c1x": 18,
          "c1y": 17,
          "c2x": 6,
          "c2y": 17,
          "x": 6,
          "y": 12
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 11,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 16
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 15,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 16
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 9,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 4
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 14,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 4
        }
      ]
    ],
    "fills": []
  },
  "apple": {
    "name": "apple",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 8
        },
        {
          "kind": "curveTo",
          "c1x": 5,
          "c1y": 5,
          "c2x": 3,
          "c2y": 15,
          "x": 8,
          "y": 20
        },
        {
          "kind": "curveTo",
          "c1x": 11,
          "c1y": 22,
          "c2x": 13,
          "c2y": 22,
          "x": 16,
          "y": 20
        },
        {
          "kind": "curveTo",
          "c1x": 21,
          "c1y": 15,
          "c2x": 19,
          "c2y": 5,
          "x": 12,
          "y": 8
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 4
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 5
        },
        {
          "kind": "lineTo",
          "x": 16,
          "y": 3
        }
      ]
    ],
    "fills": []
  },
  "car": {
    "name": "car",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 3,
          "y": 16
        },
        {
          "kind": "lineTo",
          "x": 3,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 16
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 7,
          "cy": 17,
          "radius": 2
        }
      ],
      [
        {
          "kind": "circle",
          "cx": 17,
          "cy": 17,
          "radius": 2
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 11,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 12
        }
      ]
    ],
    "fills": []
  },
  "ball": {
    "name": "ball",
    "strokes": [
      [
        {
          "kind": "circle",
          "cx": 12,
          "cy": 12,
          "radius": 8
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 12
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 4
        },
        {
          "kind": "curveTo",
          "c1x": 7,
          "c1y": 8,
          "c2x": 7,
          "c2y": 16,
          "x": 12,
          "y": 20
        }
      ]
    ],
    "fills": []
  },
  "book": {
    "name": "book",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 5
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 7
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 4,
          "y": 18
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 20,
          "y": 5
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 7
        },
        {
          "kind": "lineTo",
          "x": 13,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 18
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": []
  },
  "cup": {
    "name": "cup",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 5,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 19
        },
        {
          "kind": "lineTo",
          "x": 7,
          "y": 19
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 17,
          "y": 9
        },
        {
          "kind": "curveTo",
          "c1x": 21,
          "c1y": 9,
          "c2x": 21,
          "c2y": 15,
          "x": 16,
          "y": 15
        }
      ]
    ],
    "fills": []
  },
  "tree": {
    "name": "tree",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 5,
          "y": 13
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 13
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 8
        },
        {
          "kind": "lineTo",
          "x": 7,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 17
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 17
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 21
        }
      ]
    ],
    "fills": []
  },
  "house": {
    "name": "house",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 3,
          "y": 11
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 4
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 11
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 5,
          "y": 10
        },
        {
          "kind": "lineTo",
          "x": 5,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 10
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 10,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 10,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 14,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 14,
          "y": 20
        }
      ]
    ],
    "fills": []
  },
  "star": {
    "name": "star",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 14.6,
          "y": 9.3
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 9.8
        },
        {
          "kind": "lineTo",
          "x": 16.2,
          "y": 14.2
        },
        {
          "kind": "lineTo",
          "x": 17.7,
          "y": 20.6
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 17.2
        },
        {
          "kind": "lineTo",
          "x": 6.3,
          "y": 20.6
        },
        {
          "kind": "lineTo",
          "x": 7.8,
          "y": 14.2
        },
        {
          "kind": "lineTo",
          "x": 3,
          "y": 9.8
        },
        {
          "kind": "lineTo",
          "x": 9.4,
          "y": 9.3
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": []
  },
  "hat": {
    "name": "hat",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 7,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 6
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 14
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 3,
          "y": 14
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 14
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 11
        },
        {
          "kind": "lineTo",
          "x": 17,
          "y": 11
        }
      ]
    ],
    "fills": []
  },
  "drum": {
    "name": "drum",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 9
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 9
        },
        {
          "kind": "lineTo",
          "x": 18,
          "y": 18
        },
        {
          "kind": "lineTo",
          "x": 6,
          "y": 18
        },
        {
          "kind": "close"
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 9
        },
        {
          "kind": "lineTo",
          "x": 11,
          "y": 13
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 9
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 7,
          "y": 7
        },
        {
          "kind": "lineTo",
          "x": 9,
          "y": 3
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 17,
          "y": 7
        },
        {
          "kind": "lineTo",
          "x": 15,
          "y": 3
        }
      ]
    ],
    "fills": []
  },
  "circle": {
    "name": "circle",
    "strokes": [
      [
        {
          "kind": "circle",
          "cx": 12,
          "cy": 12,
          "radius": 8
        }
      ]
    ],
    "fills": []
  },
  "square": {
    "name": "square",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 4,
          "y": 4
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 4
        },
        {
          "kind": "lineTo",
          "x": 20,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 4,
          "y": 20
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": []
  },
  "triangle": {
    "name": "triangle",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 20
        },
        {
          "kind": "lineTo",
          "x": 3,
          "y": 20
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": []
  },
  "diamond": {
    "name": "diamond",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 12
        },
        {
          "kind": "lineTo",
          "x": 12,
          "y": 21
        },
        {
          "kind": "lineTo",
          "x": 3,
          "y": 12
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": []
  },
  "pentagon": {
    "name": "pentagon",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 12,
          "y": 3
        },
        {
          "kind": "lineTo",
          "x": 21,
          "y": 9.7
        },
        {
          "kind": "lineTo",
          "x": 17.6,
          "y": 20.3
        },
        {
          "kind": "lineTo",
          "x": 6.4,
          "y": 20.3
        },
        {
          "kind": "lineTo",
          "x": 3,
          "y": 9.7
        },
        {
          "kind": "close"
        }
      ]
    ],
    "fills": []
  },
  "cross": {
    "name": "cross",
    "strokes": [
      [
        {
          "kind": "moveTo",
          "x": 5,
          "y": 5
        },
        {
          "kind": "lineTo",
          "x": 19,
          "y": 19
        }
      ],
      [
        {
          "kind": "moveTo",
          "x": 19,
          "y": 5
        },
        {
          "kind": "lineTo",
          "x": 5,
          "y": 19
        }
      ]
    ],
    "fills": []
  }
};
